module.exports = __webpack_public_path__ + "static/media/mobile_vehiclerecall_video.124124cf.png";